import SimulationNeedsForm from './SimulationNeedsForm.jsx';
import { compose } from 'ramda';
import { Loading } from '@fasstech/middle-design-system';
import withMiddleFeatures from '@@viewCommonHoc/withMiddleFeatures';
import withGlobalData from '@@viewCommonHoc/withGlobalData.jsx';
import useGetSimulationNeedsQuery from './hooks/useGetSimulationNeedsQuery.js';
import useGetSimulationNeedsSubscribersQuery from './hooks/useGetSimulationNeedsSubscribersQuery.js';

const SimulationNeeds = ({
  middleFeatures,
  getMiddleText,
  getMiddleBoolean,
  regimeObligatoire,
  viewMode
}) => {
  const { getSimulationNeedsSubscribers, loading: loadingGetSimulationNeedsSubscribers } =
    useGetSimulationNeedsSubscribersQuery();

  const { getSimulationNeeds, loading: loadingGetSimulationNeeds } = useGetSimulationNeedsQuery();

  if (loadingGetSimulationNeedsSubscribers || loadingGetSimulationNeeds) {
    return <Loading />;
  }

  return (
    <SimulationNeedsForm
      getSimulationNeedsSubscribers={getSimulationNeedsSubscribers}
      getSimulationNeeds={getSimulationNeeds}
      middleFeatures={middleFeatures}
      getMiddleText={getMiddleText}
      getMiddleBoolean={getMiddleBoolean}
      regimeObligatoire={regimeObligatoire}
      viewMode={viewMode}
    />
  );
};

export default compose(withMiddleFeatures, withGlobalData)(SimulationNeeds);
